/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Automation_Retry_Requires_FailedInputs */

const en_api_error_automation_retry_requires_failed = /** @type {(inputs: Api_Error_Automation_Retry_Requires_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only a failed run can be retried.`)
};

const pt_br2_api_error_automation_retry_requires_failed = /** @type {(inputs: Api_Error_Automation_Retry_Requires_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somente uma execução com falha pode ser tentada novamente.`)
};

/**
* | output |
* | --- |
* | "Only a failed run can be retried." |
*
* @param {Api_Error_Automation_Retry_Requires_FailedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_automation_retry_requires_failed = /** @type {((inputs?: Api_Error_Automation_Retry_Requires_FailedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Automation_Retry_Requires_FailedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_automation_retry_requires_failed(inputs)
	return pt_br2_api_error_automation_retry_requires_failed(inputs)
});